import { useState } from 'react'

import { Column } from '../../../../components/layouts/columns'
import { Button } from '../../../../components/ui/button'
import { Input } from '../../../../components/ui/input'
import { Modal } from '../../../../components/ui/modal'
import { Select } from '../../../../components/ui/select'
import { useGlobalContext } from '../../../../context/ContextGlobal'
import { TransformationforMask } from '../../../../utils/masks'

export const ModalSelectCandidacySelected = ({ loading, active = true, setActive, type, formContext, actions }) => {
  const { user } = useGlobalContext()

  const [form, setform] = useState({})

  // ✅ Movido para função para sempre capturar o valor atual do form no momento do clique
  const buildResponse = () => ({
    id: formContext?.id,
    uuid: formContext?.uuid,
    name: formContext?.name,
    cpf: formContext?.cpf,
    positionName: formContext?.positionName,
    date: formContext?.date,
    idJobOffers: formContext?.idJobOffers,
    createdBy: user?.user?.nome,
    ...(type === 'debts' && {
      motivoDebt: form?.motivoDebt,
      valueDebt: form?.valueDebt,
      typeDebt: form?.typeDebt,
    }),
  })

  if (active) {
    if (type === 'debts') {
      return (
        <div>
          <Modal.Root active={active}>
            <Modal.Contents witdh={700}>
              <Modal.Header title={'Adicionar Aporte/Desconto'}>
                <Modal.HeaderClose setActive={setActive}></Modal.HeaderClose>
              </Modal.Header>

              <Modal.Body>
                <Column.Root>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                        Nome
                      </Input.Label>
                      <Input.Contents>
                        <Input.ReadOnly className="is-rounded" color="is-grey">
                          {TransformationforMask(formContext.name, 'title')}
                        </Input.ReadOnly>
                      </Input.Contents>
                    </Input.Root>
                  </Column.Content>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                        CPF
                      </Input.Label>
                      <Input.Contents>
                        <Input.ReadOnly className="is-rounded" color="is-grey">
                          {formContext.cpf}
                        </Input.ReadOnly>
                      </Input.Contents>
                    </Input.Root>
                  </Column.Content>
                </Column.Root>

                <Column.Root>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                        Data
                      </Input.Label>
                      <Input.Contents>
                        <Input.ReadOnly className="is-rounded" color="is-grey">
                          {formContext.jobOffer.date}
                        </Input.ReadOnly>
                      </Input.Contents>
                    </Input.Root>
                  </Column.Content>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                        Turno
                      </Input.Label>
                      <Input.Contents>
                        <Input.ReadOnly className="is-rounded" color="is-grey">
                          {formContext.jobOffer.round}
                        </Input.ReadOnly>
                      </Input.Contents>
                    </Input.Root>
                  </Column.Content>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                        Vaga
                      </Input.Label>
                      <Input.Contents>
                        <Input.ReadOnly className="is-rounded" color="is-grey">
                          {formContext.jobOffer.position.name || formContext.jobOffer.position.nome}
                        </Input.ReadOnly>
                      </Input.Contents>
                    </Input.Root>
                  </Column.Content>
                </Column.Root>

                <Column.Root>
                  <Column.Content>
                    <Select.Root>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                        Aporte/Desconto:
                      </Input.Label>
                      <Select.Content
                        required={true}
                        color="is-grey"
                        value={form}
                        setValue={setform}
                        field={'typeDebt'}
                        className="is-fullwidth is-rounded is-danger"
                      >
                        <Select.Option value="D" title="Desconto" />
                        <Select.Option value="C" title="Aporte" />
                      </Select.Content>
                    </Select.Root>
                  </Column.Content>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                        Valor:
                      </Input.Label>
                      <Input.Contents alignIcon={'left'}>
                        <Input.Icon align="left" className="has-text-grey">
                          R$
                        </Input.Icon>
                        <Input.Prompt
                          className="is-rounded is-danger"
                          color="is-grey"
                          value={form}
                          setValue={setform}
                          field={'valueDebt'}
                        />
                      </Input.Contents>
                    </Input.Root>
                  </Column.Content>
                </Column.Root>

                <Column.Root>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                        Motivo:
                      </Input.Label>
                      <Input.Contents>
                        <Input.Textarea
                          style={{ borderRadius: 20 }}
                          className="is-danger"
                          color="is-grey"
                          value={form}
                          setValue={setform}
                          field={'motivoDebt'}
                        />
                      </Input.Contents>
                    </Input.Root>
                  </Column.Content>
                </Column.Root>
              </Modal.Body>

              <Modal.Footer>
                <Button.Bt
                  className="has-background-dark has-text-white"
                  action={() => {
                    // ✅ buildResponse() chamado no momento do clique, capturando o form atualizado
                    actions.select(buildResponse(), true, false)
                  }}
                >
                  Salvar
                </Button.Bt>

                <Button.Bt
                  className="has-background-grey-light has-text-dark"
                  action={() => {
                    // ✅ buildResponse() chamado no momento do clique, capturando o form atualizado
                    actions.select(buildResponse(), true, true)
                    setform({})
                  }}
                >
                  Salvar e Adicionar outro
                </Button.Bt>

                <Button.Bt
                  action={() => {
                    setform({})
                    setActive(false)
                  }}
                >
                  Cancelar
                </Button.Bt>
              </Modal.Footer>
            </Modal.Contents>
          </Modal.Root>
        </div>
      )
    } else {
      return <></>
    }
  } else {
    return <></>
  }
}
